import { useEffect } from "react";
import { getChats } from "../helpers/fetch";
import { FILTER_VALUE_ACTIVOS } from "../const/filtersValue/filterValue";
import { socketIsConnected } from "../config/socket";  // Importar la función que verifica la conexión del socket


// useGetChatInInbox: Hook que trae los chats y depende solo del localStorage y la conexión del socket.
// Si está conectado el socket, se guarda en el localStorage "connect", y si se desconecta se guarda "disconnect",
// por lo que este hook detecta el cambio, y de acuerdo a ella hace o no la petición para traer los chats.

const useGetChatInInbox = ({ setChatsArray, setChatsOriginal, setPeticionChatsSuccess, setLoading }) => {

    useEffect(() => { //Se ejecuta al renderizar el componente para traer los chats.
        const onGetChat = async () => {
            
            const responseChats = await getChats({
                filter: FILTER_VALUE_ACTIVOS,
                idLastChatPosition: undefined
            }); // Invoca a la función para traer los chats.
            setChatsArray(responseChats); // Setea la lista de chats que es visible en el inbox (la que se puede filtrar por busqueda).
            setChatsOriginal(responseChats); // Setea la lista de chats original, la que contiene todos los chats al renderizar el componente.
            setPeticionChatsSuccess(true);  // Petición exitosa
            setLoading(false);  // Ocultar los botones de cargando...
        };

        const checkConnectionAndFetchChats = () => {
            if (socketIsConnected()) {
                onGetChat();
            } else {
                console.log("El socket NO está conectado, NO voy a traer los chats");
            }
        };

        // Ejecutar al montar el componente
        checkConnectionAndFetchChats();

        // Listener para cambios en localStorage
        const handleStorageChange = () => {
            checkConnectionAndFetchChats();
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, [setChatsArray, setChatsOriginal, setPeticionChatsSuccess, setLoading]);

};

export default useGetChatInInbox;
